/**
 * The ONLINE screen's body (ACT HQ t-492): where the race being joined stands, and who's
 * on the grid so far. The screen itself is in Menu.
 */
import { VD_ONLINE_SEATS, type VdOnlineRacePayload } from "@act/shared";
import { getShipById } from "../config/ships";
import { shipIcon } from "./marks";
import { esc } from "./profileView";

export interface OnlineView {
  status: "connecting" | "waiting" | "error";
  race?: VdOnlineRacePayload | null;
  /** The room's clock now, for the countdown to the bots. */
  serverNow?: () => number;
  message?: string;
}

function statusText(view: OnlineView): string {
  if (view.status === "connecting") return "CONNECTING…";
  if (view.status === "error") return esc(view.message ?? "Couldn't join a race.");
  const race = view.race;
  if (!race) return "JOINING…";
  if (race.phase !== "waiting") return "GRID SET · STARTING";
  const people = race.racers.filter((r) => !r.bot).length;
  const s = Math.max(0, Math.ceil((race.fillAt - (view.serverNow?.() ?? race.now)) / 1000));
  return `WAITING FOR RACERS · ${people}/${VD_ONLINE_SEATS} · BOTS IN ${s}S`;
}

/** The body, or with `statusOnly` just the status line's text (refreshed every frame). */
export function onlineBodyHtml(view: OnlineView, statusOnly = false): string {
  const status = statusText(view);
  if (statusOnly) return status;
  const race = view.race;
  const rows = (race?.racers ?? [])
    .map((r) => {
      const ship = getShipById(r.ship);
      const tag = r.slot === race?.you ? `<b class="you">YOU</b>` : r.bot ? `<b>BOT</b>` : "";
      return `
        <div class="vd-ol-row ${r.slot === race?.you ? "you" : ""}">
          <span class="vd-ol-emblem">${shipIcon(ship.id, ship.color.toHexString())}</span>
          <span class="vd-ol-name">${esc(r.name)}</span>
          <span class="vd-ol-ship">${ship.code}</span>
          ${tag}
        </div>`;
    })
    .join("");
  return `
    <div class="vd-ol-body">
      <div class="vd-ol-status ${view.status === "error" ? "err" : ""}">${status}</div>
      <div class="vd-ol-list">${rows}</div>
    </div>`;
}
